const variants = {
  variant: {
    default: 'btn--default',
    link: 'btn--link',
    outline: 'btn--outline',
  },
  size: {
    base: 'btn--size-base',
    sm: 'btn--size-sm',
    icon: 'btn--size-icon',
    iconsm: 'btn--size-iconsm',
    iconlg: 'btn--size-iconlg',
  },
  mobile: {
    default: '',
    full: 'btn--mobile-full',
    block: 'btn--mobile-block',
    sm: 'btn--mobile-sm',
    md: 'btn--mobile-md',
  },
};

export const Button = ({
  children,
  href = null,
  target = null,
  disabled = null,
  download = null,
  type = 'button',
  variant = 'default',
  size = 'base',
  mobile = 'default',
  onClick,
  tracking = null,
  theme = null,
  className = '',
  ...props
}) => {
  const TagName = href ? 'a' : 'button';
  const linkProps = { href, target };
  const buttonProps = { type };

  const cssClasses = [
    'btn',
    variants.size[size],
    variants.variant[variant],
    variants.mobile[mobile],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <TagName
      {...(href ? linkProps : buttonProps)}
      onClick={onClick}
      className={cssClasses}
      data-tracking={tracking}
      data-theme={theme}
      disabled={disabled}
      download={download}
      {...props}
    >
      {children}
    </TagName>
  );
};
